module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Heavy.fad20ab2.otf";